module.exports = __webpack_public_path__ + "static/DINPro-363bae629ce0da739c4fa1063b883f5a.woff";